import FooterSection from './footer-section-view'
export default FooterSection
